import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';
import { getEnv } from '../env';
import { getUserRoles } from '../http';

function getOwlCoreStudyPath(studyId: string, roles: string[]): string {
  if (roles.includes('scorer')) return `/scorer-studies/${studyId}`;
  if (roles.includes('clinician')) return `/studies/${studyId}`;
  if (roles.includes('service_delivery')) return `/service-delivery/${studyId}/detail`;
  return `/studies/${studyId}`;
}

export function useOwlCoreStudyUrl() {
  const route = useRoute();
  const userRoles = ref<string[]>([]);

  getUserRoles().then((roles) => (userRoles.value = roles));

  return computed(
    () =>
      `${getEnv().OWL_CORE_URL}${getOwlCoreStudyPath(route.params.id as string, userRoles.value)}`
  );
}
